import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertTiffToJpg() {
  return (
    <ImageConverterTemplate
      sourceFormat="TIFF"
      targetFormat="JPG"
      acceptTypes=".tiff,.tif,image/tiff"
      slug="convert-tiff-to-jpg"
      gradientColors="from-purple-500 to-orange-500"
      accentColor="orange"
      showQualitySlider={true}
    />
  );
}
